/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ForcingSubstance } from "./ForcingSubstance";
import {
  ForcingSubstanceFromJSON,
  ForcingSubstanceFromJSONTyped,
  ForcingSubstanceToJSON,
  ForcingSubstanceToJSONTyped,
} from "./ForcingSubstance";
import type { LateralUnitsEnum } from "./LateralUnitsEnum";
import {
  LateralUnitsEnumFromJSON,
  LateralUnitsEnumFromJSONTyped,
  LateralUnitsEnumToJSON,
  LateralUnitsEnumToJSONTyped,
} from "./LateralUnitsEnum";
import type { Point } from "./Point";
import { PointFromJSON, PointFromJSONTyped, PointToJSON, PointToJSONTyped } from "./Point";
import type { EventStateEnum } from "./EventStateEnum";
import {
  EventStateEnumFromJSON,
  EventStateEnumFromJSONTyped,
  EventStateEnumToJSON,
  EventStateEnumToJSONTyped,
} from "./EventStateEnum";

/**
 * Assumes simulation to be present on Serializer.
 *
 * Validates that the latest simulation status is either "created" or
 * "initialized".
 *
 * If the latest simulation status is "initialized" is also checks
 * if the simulation has been paused.
 *
 * Use this mixin to validate the creation or update of simulation event
 * resources like rain, wind etc
 * @export
 * @interface TimeseriesLateral
 */
export interface TimeseriesLateral {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly simulation?: string;
  /**
   * offset of event in simulation in seconds
   */
  offset: number;
  /**
   *
   */
  interpolate?: boolean;
  /**
   * Timeseries provided as a nested list. The inner list consists of exactly 2 values: timestamp, value
   */
  values: Array<Array<number>>;
  /**
   * 'm3/s' (only option for now)
   *
   * * `m3/s` - m3/s
   */
  units: LateralUnitsEnum;
  /**
   *
   */
  point?: Point;
  /**
   *
   */
  connectionNode?: number | null;
  /**
   *
   */
  readonly state?: EventStateEnum;
  /**
   *
   */
  readonly stateDetail?: any | null;
  /**
   *
   */
  readonly gridId?: number | null;
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  readonly uid?: string;
  /**
   *
   */
  substances?: Array<ForcingSubstance>;
}

/**
 * Check if a given object implements the TimeseriesLateral interface.
 */
export function instanceOfTimeseriesLateral(value: object): value is TimeseriesLateral {
  if (!("offset" in value) || value["offset"] === undefined) return false;
  if (!("values" in value) || value["values"] === undefined) return false;
  if (!("units" in value) || value["units"] === undefined) return false;
  return true;
}

export function TimeseriesLateralFromJSON(json: any): TimeseriesLateral {
  return TimeseriesLateralFromJSONTyped(json, false);
}

export function TimeseriesLateralFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TimeseriesLateral {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    offset: json["offset"],
    interpolate: json["interpolate"] == null ? undefined : json["interpolate"],
    values: json["values"],
    units: LateralUnitsEnumFromJSON(json["units"]),
    point: json["point"] == null ? undefined : PointFromJSON(json["point"]),
    connectionNode:
      json["connection_node"] === undefined
        ? undefined
        : json["connection_node"] === null
        ? null
        : json["connection_node"],
    state: json["state"] == null ? undefined : EventStateEnumFromJSON(json["state"]),
    stateDetail:
      json["state_detail"] === undefined
        ? undefined
        : json["state_detail"] === null
        ? null
        : json["state_detail"],
    gridId:
      json["grid_id"] === undefined ? undefined : json["grid_id"] === null ? null : json["grid_id"],
    id: json["id"] == null ? undefined : json["id"],
    uid: json["uid"] == null ? undefined : json["uid"],
    substances:
      json["substances"] == null
        ? undefined
        : (json["substances"] as Array<any>).map(ForcingSubstanceFromJSON),
  };
}

export function TimeseriesLateralToJSON(json: any): TimeseriesLateral {
  return TimeseriesLateralToJSONTyped(json, false);
}

export function TimeseriesLateralToJSONTyped(
  value?: Omit<
    TimeseriesLateral,
    "url" | "simulation" | "state" | "stateDetail" | "gridId" | "id" | "uid"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    offset: value["offset"],
    interpolate: value["interpolate"],
    values: value["values"],
    units: LateralUnitsEnumToJSON(value["units"]),
    point: PointToJSON(value["point"]),
    connection_node: value["connectionNode"],
    substances:
      value["substances"] == null
        ? undefined
        : (value["substances"] as Array<any>).map(ForcingSubstanceToJSON),
  };
}
